const Marionette = require('backbone.marionette');
const _ = require('lodash');
_.mixin(require('../extensions/lodash.js'));

require('../extensions/mixin.js');

const Dashboard = Marionette.Dashboard = module.exports;
Dashboard.Router = require('../router.js');

Dashboard.models = {};
Dashboard.models.Model = require('../models/model.js');
Dashboard.models.Configuration = require('../models/configuration.js');
Dashboard.models.Curation = require('../models/curation.js');
Dashboard.models.Widget = require('../models/widget.js');

Dashboard.mixins = {};
Dashboard.mixins.Props = require('../mixins/props.js');
Dashboard.mixins.Loading = require('../mixins/loading.js');
Dashboard.mixins.Filters = require('../mixins/filters.js');
Dashboard.mixins.AsyncRenderWatch = require('../mixins/asyncRenderWatch.js');

Dashboard.views = {};
_.extend(Dashboard.views, require('../views/loading.js'));
Dashboard.views.Widgets = require('../views/widgets.js');
Dashboard.views.BlockLoading = require('../views/blockLoading.js');

Dashboard.widgets = require('../widgets.js');

Dashboard.Controller = require('../controller.js');

Dashboard.utils = {};
Dashboard.utils.params = require('../utils/params.js');
Dashboard.utils.object = require('../utils/object.js');
